/**
 * @Injectable
 * All services for a setting model
 *
 */

import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';

import { environment } from '../../../environments/environment';
import { Setting } from '../models/setting.model';
import { HttpService } from './http.service';


@Injectable()

export class SettingService {

  constructor(
    protected http: HttpService
  ) { }


  /**
	 * Build current setting service API base url
   *
   * @param		  {String}      API base url
   * @return		{String}      API base url
   */
 	protected getUrl(slug: string): string {
    return environment.apiUrl + slug + '/';
  }

  /**
	 * Get instances of the current setting
   *
   * @param		  {String}       setting type
   * @param		  {String}       an optionnal query string
	 * @return		{Promise}      Array of all settings found
   */
  getItems(slug: string, query?: string): Promise<Setting[]> {
    query = (query ? '?filter=' + encodeURIComponent(JSON.stringify({where: {label: {regexp: '^.*' + query + '.*$/i'}}})) : '');
    return this.http.get(this.getUrl(slug) + query)
               .toPromise()
               .then(response => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/setting.service.ts